var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsInfoRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-info 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#FEF4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 2C7.82759 2 2 7.82759 2 15C2 22.1724 7.82759 28 15 28C22.1724 28 28 22.1724 28 15C28 7.82759 22.1724 2 15 2ZM15 3.34483C21.4328 3.34483 26.6552 8.56724 26.6552 15C26.6552 21.4328 21.4328 26.6552 15 26.6552C8.56724 26.6552 3.34483 21.4328 3.34483 15C3.34483 8.56724 8.56724 3.34483 15 3.34483ZM15 7.37931C14.465 7.37931 13.9519 7.59184 13.5736 7.97015C13.1953 8.34845 12.9828 8.86155 12.9828 9.39655C12.9828 9.93156 13.1953 10.4447 13.5736 10.823C13.9519 11.2013 14.465 11.4138 15 11.4138C15.535 11.4138 16.0481 11.2013 16.4264 10.823C16.8047 10.4447 17.0172 9.93156 17.0172 9.39655C17.0172 8.86155 16.8047 8.34845 16.4264 7.97015C16.0481 7.59184 15.535 7.37931 15 7.37931ZM15 13.8793C13.8793 13.8793 12.9828 14.7759 12.9828 15.8966V21.2759C12.9828 22.3966 13.8793 23.2931 15 23.2931C16.1207 23.2931 17.0172 22.3966 17.0172 21.2759V15.8966C17.0172 14.7759 16.1207 13.8793 15 13.8793Z",
    fill: "#F45045"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsInfoRed);
export default __webpack_public_path__ + "static/media/iconsInfoRed.edbcac3e5d27f19a735c8caeeffa0384.svg";
export { ForwardRef as ReactComponent };